import React, { useState, useEffect } from 'react';
import { Button, TextField, Card, CardContent, Typography, IconButton } from '@mui/material';
import { Delete, Edit, CloudUpload } from '@mui/icons-material';
import { deleteSupplierCertificate } from '../service/certificateService'; 
import FormInstructionBox from '../components/FormInstructionBox';

const cardStyle = {
  border: "1px solid",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  transition: "box-shadow 0.3s ease",
};

export default function CertificateForm({ data, updateData, handleNext, handleBack, handleSave,  mode }) {
  const [certificates, setCertificates] = useState(data || []);
  const [cert, setCert] = useState(initialCert());
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
   const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
  
  const certInstructions = [
        "The ** Name** is the Name of the certificate ex: FSSAI , ISO etc,",
        "The **Certificate Number** is the Number provided by the Governing Authority .",
        "The **Type** fill in the type of the certificate. ",
        "The **Expiry Date** is mandatory. if you dont have expiry date fill in 12-12-2999",
        "Click 'Edit and Update' to apply changes, or 'Cancel' to discard.",
        "When you create or edit Certificate, After ADD CERTIFICATE, You much click on Update/Submit/Save.",
        "If you have any Questions or need more help. Please contact the System Administrator.WhatsApp or Phone: +91 999 464 1128"
    ];


  function initialCert() {
    return {
      certificateId: '',
      name: '',
      certificateNumber: '',
      type: '',
      issueDate: '',
      expiryDate: '', 
      issuingAuthority: '',
      file: null,
      fileName: ''
    };
  } 
  
    useEffect(() => {
      
        if(certificates){
            updateData(certificates);
        }
        }, [certificates]);


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCert(prev => ({
        ...prev,
        file,
        fileName: file.name
      }));
    }
  };

  const handleAddOrUpdate = () => {

    console.log(certificates);
      console.log("certificate id: "+ certificates[0]?.certificateId); 
    
               if (
   
    !cert.name ||
    !cert.type ||
    !cert.issueDate ||
    !cert.expiryDate ||
    !cert.issuingAuthority 
  ) {
    alert("Please fill in all required fields.");
    return;
  }
    
    
    if (isEditing) {
      const updated = [...certificates];
      updated[editingIndex] = cert;
      setCertificates(updated);
      setIsEditing(false);
      setEditingIndex(null);
    } else {
      setCertificates(prev => [...prev, cert]);
    }
    
     console.log("after :",certificates);
    setCert(initialCert());
    setIsUpdateDisabled(false);
  };

  const handleEdit = (index) => {
    setCert(certificates[index]);
    setEditingIndex(index);
    setIsEditing(true);
  };

  const handleDelete = (index) => {
    
    const certificateAtIndex = certificates[index];
    
    if((mode && mode === "dashboard") && certificateAtIndex?.certificateId){
      
       if (window.confirm("Are you sure you want to delete this certificate?")) {
    try {
      deleteSupplierCertificate(certificateAtIndex.certificateId);
      
       const updated = certificates.filter((_, i) => i !== index);
    setCertificates(updated);
    if (isEditing && editingIndex === index) {
      setIsEditing(false);
      setEditingIndex(null);
      setCert(initialCert());
   
    }
      
    }catch (err) {
      console.error("Error deleting discount:", err);
    }
       }
      
      
    }else{
      
          const updated = certificates.filter((_, i) => i !== index);
    setCertificates(updated);
    if (isEditing && editingIndex === index) {
      setIsEditing(false);
      setEditingIndex(null);
      setCert(initialCert());
    }
    }
    
    

  };

  const handleNextStep = () => {
    if(certificates.length==0){
      alert("Add certificate and then click next! ");
      return;
    }
    
    updateData(certificates);
    handleNext();
  };
  
  const handleUpdate = () => {
    handleAddOrUpdate();
    updateData(certificates);
    
      console.log("handle update :",certificates);
    
    handleNext();
  };
  
    const handleUpdateCertificate = () => {
      updateData(certificates);
      handleSave();

  setIsUpdateDisabled(true);
    };

  return (
    <div className="space-y-4">
      {/* Existing Certificates Display */}
      {certificates.map((item, index) => (
        <>
        <Card key={index} variant="outlined"  style={{ ...cardStyle, borderColor: "#F44336" }}>
          <CardContent className="flex justify-between items-center">
            <div>
             
            <Typography variant="subtitle1" style={{ fontWeight: "bold" , textTransform: "uppercase"}}>
              {item.name}
            </Typography>
            <Typography variant="body2">
                No: {item.certificateNumber} | Type: {item.type}<br />
                Issue: {item.issueDate} | Expiry: {item.expiryDate}<br />
                Authority: {item.issuingAuthority}
              </Typography>
              {item.fileName && (
                <Typography variant="body2" className="mt-1">
                  File: {item.fileName}
                </Typography>
              )}
            </div>
            {!item.certificateId && (
            <div>
              <IconButton onClick={() => handleEdit(index)}><Edit /></IconButton>
              <IconButton onClick={() => handleDelete(index)}><Delete /></IconButton>
            </div>
            )}
          </CardContent>
        </Card>
<br/>
</>
      ))}
<br/>
      {/* Certificate Form */}
 <input type="hidden" value={cert.certificateId} onChange={e => setCert({ ...cert, certificateId: e.target.value })} />
      <TextField label="Name" fullWidth value={cert.name} onChange={e => setCert({ ...cert, name: e.target.value })} required />
      <TextField label="Certificate Number" fullWidth value={cert.certificateNumber} onChange={e => setCert({ ...cert, certificateNumber: e.target.value })} required />
      <TextField label="Type" fullWidth value={cert.type} onChange={e => setCert({ ...cert, type: e.target.value })} required />
      <TextField label="Issue Date" type="date" InputLabelProps={{ shrink: true }} fullWidth value={cert.issueDate} onChange={e => setCert({ ...cert, issueDate: e.target.value })} required/>
      <TextField label="Expiry Date" type="date" InputLabelProps={{ shrink: true }} fullWidth value={cert.expiryDate} onChange={e => setCert({ ...cert, expiryDate: e.target.value })} required/>
      <TextField label="Issuing Authority" fullWidth value={cert.issuingAuthority} onChange={e => setCert({ ...cert, issuingAuthority: e.target.value })} required/>

    {/*   <div className="flex items-center space-x-2">
        <Button component="label" variant="outlined" startIcon={<CloudUpload />}>
          Upload Certificate
          <input type="file" hidden onChange={handleFileChange} />
        </Button>
        <span>{cert.fileName}</span>
      </div>
      */}

      <Button variant="outlined" onClick={handleAddOrUpdate}>
        {isEditing ? 'Update Certificate' : 'Add Certificate'}
      </Button>
 {!(mode && mode === "dashboard") ? (
   <>
      {/* Navigation Buttons */}
      <div className="flex justify-between mt-4">
        <Button onClick={handleBack}>Back</Button>
        <Button variant="contained" onClick={handleNextStep}>Next</Button>
      </div>
     </>
        ) : ( 
          <>
                  <Button variant="contained" color="primary" disabled={isUpdateDisabled} onClick={handleUpdateCertificate}>
            Update
          </Button>
</>
         )}
               <FormInstructionBox 
                instructions={certInstructions} 
                title="Certificate Details Guidelines" 
            />
    </div>
  );
}
